import { createAction } from "@reduxjs/toolkit";

import { Actions } from "../../types/actions.types";

export const getEnumsAction = createAction(Actions.getEnums);
export const getSettingsAction = createAction(Actions.getSettings);
